"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.join = exports.withParams = exports.addMergingArgumentPrefix = exports.addSplittingArgumentPrefix = exports.addPrefix = exports.mataRoutePathKey = void 0;
/* eslint-disable max-params */
const path_browserify_1 = require("path-browserify");
Object.defineProperty(exports, "join", { enumerable: true, get: function () { return path_browserify_1.join; } });
function addPrefix(prefix, routePrefix = prefix) {
    const strategy = typeof prefix === "string" ? sameArgumentsStrategy : HOFStrategy;
    return (object) => {
        return addPrefixHelper(object, prefix, routePrefix, strategy);
    };
}
exports.addPrefix = addPrefix;
const addMergingArgumentPrefix = (getUrl, routePath) => {
    return (object) => {
        return addPrefixHelper(object, getUrl, routePath, sameArgumentsStrategy);
    };
};
exports.addMergingArgumentPrefix = addMergingArgumentPrefix;
const addSplittingArgumentPrefix = (getUrl, routePath) => {
    return (object) => {
        return addPrefixHelper(object, getUrl, routePath, argumentsSplitStrategy);
    };
};
exports.addSplittingArgumentPrefix = addSplittingArgumentPrefix;
const addPrefixHelper = (obj, prefix, routePrefix, merge) => {
    const newObj = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (typeof obj[key] === "object") {
                newObj[key] = addPrefixHelper(obj[key], prefix, routePrefix, merge);
            }
            else {
                newObj[key] = addPath(prefix, routePrefix, obj[key], merge);
            }
        }
    }
    return newObj;
};
const asFunction = (value) => {
    if (typeof value === "function")
        return value;
    return (() => value);
};
const addPath = (prefix, routePrefix, to, merge) => {
    const merged = asFunction(merge(prefix, to));
    if (typeof to === "function" &&
        to[exports.mataRoutePathKey] !== undefined) {
        merged[exports.mataRoutePathKey] = merge(routePrefix, to[exports.mataRoutePathKey]);
    }
    else if (typeof to === "string") {
        merged[exports.mataRoutePathKey] = merge(routePrefix, to);
    }
    return merged;
};
const createMergeStrategy = (merge) => {
    return (prefix, to) => {
        if (typeof to === "string") {
            if (typeof prefix === "string") {
                return path_browserify_1.join(prefix, to);
            }
            else {
                return (...args) => {
                    return path_browserify_1.join(prefix(...args), to);
                };
            }
        }
        const fn = merge(typeof prefix === "string" ? () => prefix : prefix);
        return (...args) => {
            const { toArgs, prefixStr } = fn(...args);
            const rec = recursiveJoin(prefixStr, to);
            if (toArgs === null)
                return rec;
            return rec(...toArgs);
        };
    };
};
const sameArgumentsStrategy = createMergeStrategy(prefix => {
    return (...args) => ({
        prefixStr: prefix(...args),
        toArgs: args,
    });
});
const argumentsSplitStrategy = createMergeStrategy(prefix => {
    return (...args) => {
        const prefixArgs = args.slice(0, prefix.length);
        const toArgs = args.slice(prefix.length);
        return {
            prefixStr: prefix(...prefixArgs),
            toArgs,
        };
    };
});
const HOFStrategy = createMergeStrategy(prefix => {
    return (...args) => ({
        prefixStr: prefix(...args),
        toArgs: null,
    });
});
const recursiveJoin = (prefix, to) => {
    return (...args) => {
        const res = to(...args);
        if (typeof res === "function") {
            return recursiveJoin(prefix, res);
        }
        return path_browserify_1.join(prefix, res);
    };
};
exports.mataRoutePathKey = "routePath";
const withParams = (getUrl, routePath) => {
    const newFn = (...args) => {
        return getUrl(...args);
    };
    newFn[exports.mataRoutePathKey] = routePath;
    return newFn;
};
exports.withParams = withParams;
